import Uri from 'urijs';
import config from 'Config';
import {
  GOOGLE_API_DOMAIN,
  GOOGLE_API_KEY,
  GOOGLE_API_JS_PATH,
  GOOGLE_PLACE_URL,
} from './google.constants';
export function getGoogleBaseUrl(): Uri {
  const googleDomain = config.get(GOOGLE_API_DOMAIN);
  const googleKey = config.get(GOOGLE_API_KEY);
  return new Uri(googleDomain).query({
    key: googleKey,
  });
}
export function getGoogleScriptUrl(): string {
  return getGoogleBaseUrl().path(config.get(GOOGLE_API_JS_PATH)).toString();
}
export function getStaticMapURL(path: string, query: {}): string {
  const baseUrl = getGoogleBaseUrl();
  baseUrl.path(config.get(path));
  baseUrl.addQuery(query);
  return baseUrl.toString();
}
export function getGoogleMapURL({ latitude, longitude }: { latitude: number; longitude: number }) {
  return `${GOOGLE_PLACE_URL}/${latitude},${longitude}`;
}
